import {ReactNode} from "react";
import {DibJsonNode} from "../../types";
import classes from "./booktags.module.css";

type Props = {
    node: DibJsonNode;
    children: ReactNode[];
};

export const Booktags = ({children}: Props) => {
    return <ul className={classes.booktags}>{children}</ul>;
};
